import type { DetectReaction } from "../types";

const detectReaction: DetectReaction = (htmlNode, args) => {
  const { node, onAction, documentNode } = args;

  const destroyFunctions: {
    eventName: keyof HTMLElementEventMap;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handler: (...args: any) => any;
  }[] = [];

  node.reactions?.forEach((reaction) => {
    const { trigger, action } = reaction;
    if (!node.id) {
      // eslint-disable-next-line no-console
      console.warn("[codenbtter] node has no id. skipping reaction", {
        node,
        reaction,
      });
      return;
    }

    if (!trigger || !action) {
      // eslint-disable-next-line no-console
      console.warn("[codenbtter] reaction has no trigger or action", {
        node,
        reaction,
      });
      return;
    }

    if (!documentNode) {
      // eslint-disable-next-line no-console
      console.warn("[codenbtter] documentNode is null", {
        node,
        reaction,
      });
      return;
    }

    switch (trigger.type) {
      case "ON_CLICK": {
        const nodeId = node.id;
        const nodeName = node.name;

        const handler = (e: MouseEvent) => {
          if (
            (action.type === "URL" && !action.url.trim()) ||
            (action.type === "GOTO_PAGE" &&
              ((action.urlType === "CAMPAIGN" && !action.campaignUrl?.trim()) ||
                (action.urlType === "URL" && !action.url?.trim())))
          ) {
            return;
          }

          onAction?.({
            node,
            data: { action, nodeId, trigger, nodeName },
            element: htmlNode,
            documentNode,
          });

          e.stopPropagation();
        };

        htmlNode.addEventListener("click", handler);
        destroyFunctions.push({ eventName: "click", handler });
        break;
      }

      default: {
        throw new Error("Trigger not implemented: " + trigger.type);
      }
    }
  });

  return {
    destroy() {
      destroyFunctions.forEach(({ eventName, handler }) => {
        htmlNode.removeEventListener(eventName, handler);
      });
    },
  };
};

export default detectReaction;
